var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 52,
    viewBox: "0 0 162 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_840_2959",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 162,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H161.523V52H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_840_2959)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7687 28.852H127.398V0H49.7687V28.852Z",
    stroke: "#108DA0",
    strokeWidth: 0.954181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7684 28.8508L29.3256 51.3824V21.464L49.6949 0.076053C49.7217 0.0479046 49.7684 0.0665112 49.7684 0.105155V28.8508Z",
    stroke: "#108DA0",
    strokeWidth: 0.954181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.399 28.8535L99.8366 51.3851H29.3259L49.7688 28.8535H127.399",
    stroke: "#108DA0",
    strokeWidth: 0.954181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.345 18.4029L113.269 12.4297",
    stroke: "#108DA0",
    strokeWidth: 0.954181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.848 15.5923L119.22 10.4512",
    stroke: "#108DA0",
    strokeWidth: 0.954181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35059 45.084L4.27803 49.374L7.44877 45.7266L2.35059 45.084ZM3.88972 52.0006L0 43.3438L10.2885 44.6405L3.88972 52.0006Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7961 5.92346H76.8798V4.49219H57.7961V5.92346Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7961 14.0348H68.7692V12.6035H57.7961V14.0348Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7961 22.1461H68.7692V20.7148H57.7961V22.1461Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.879 39.2711H161.523V37.8398H122.879V39.2711Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.665 45.6051H125.573V44.1738H123.665V45.6051ZM127.482 45.6051H129.39V44.1738H127.482V45.6051ZM131.298 45.6051H133.207V44.1738H131.298V45.6051ZM135.115 45.6051H137.023V44.1738H135.115V45.6051ZM138.932 45.6051H140.84V44.1738H138.932V45.6051ZM142.749 45.6051H144.657V44.1738H142.749V45.6051ZM146.565 45.6051H148.474V44.1738H146.565V45.6051ZM150.382 45.6051H152.29V44.1738H150.382V45.6051Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.995 15.3624H102.688V14.6367H100.995V15.3624Z",
    fill: "#8F8F8F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustra);
export default __webpack_public_path__ + "static/media/illustra.aa8a786dcb5f6390c7c23c7546eee54c.svg";
export { ForwardRef as ReactComponent };